import { render, staticRenderFns } from "./FieldsBlock.vue?vue&type=template&id=5971378a"
import script from "./FieldsBlock.vue?vue&type=script&lang=js"
export * from "./FieldsBlock.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports